/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { HchbCreatePatientTaskBody } from './HchbCreatePatientTaskBody';
import {
    instanceOfHchbCreatePatientTaskBody,
    HchbCreatePatientTaskBodyFromJSON,
    HchbCreatePatientTaskBodyFromJSONTyped,
    HchbCreatePatientTaskBodyToJSON,
} from './HchbCreatePatientTaskBody';
import type { HchbUploadDocumentsTaskBody } from './HchbUploadDocumentsTaskBody';
import {
    instanceOfHchbUploadDocumentsTaskBody,
    HchbUploadDocumentsTaskBodyFromJSON,
    HchbUploadDocumentsTaskBodyFromJSONTyped,
    HchbUploadDocumentsTaskBodyToJSON,
} from './HchbUploadDocumentsTaskBody';

/**
 * @type HchbTaskBody
 * 
 * @export
 */
export type HchbTaskBody = HchbCreatePatientTaskBody | HchbUploadDocumentsTaskBody;

export function HchbTaskBodyFromJSON(json: any): HchbTaskBody {
    return HchbTaskBodyFromJSONTyped(json, false);
}

export function HchbTaskBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbTaskBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return { ...HchbCreatePatientTaskBodyFromJSONTyped(json, true), ...HchbUploadDocumentsTaskBodyFromJSONTyped(json, true) };
}

export function HchbTaskBodyToJSON(value?: HchbTaskBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfHchbCreatePatientTaskBody(value)) {
        return HchbCreatePatientTaskBodyToJSON(value as HchbCreatePatientTaskBody);
    }
    if (instanceOfHchbUploadDocumentsTaskBody(value)) {
        return HchbUploadDocumentsTaskBodyToJSON(value as HchbUploadDocumentsTaskBody);
    }

    return {};
}

